import React from 'react';
import HighLightedText from 'components/highLightedText/highLightedText';
import validator from 'validator';
import { formatText } from 'core/i18n';
import { InfoTooltip } from 'components/tooltip/tooltip';
import { InputText } from 'components/inputText/inputText';

export const Email = ({
    userProfile,
    userProfileForm,
    formActions,
    submitButtonValidations,
    showEmailDisclaimer,
    setShowEmailDisclaimer,
    setEmailConfirmation,
    emailConfirmationRef,
}) => {
    const isRequired = value => value && value.length;

    const isValid = {
        email: value => validator.isEmail(value),
        emailConfirmation: value => value?.toLowerCase() === userProfile?.email?.toLowerCase(),
    };

    const handleValidation = {
        email: value => {
            formActions.change('userProfile.emailConfirmation', '');
            emailConfirmationRef.current.value = '';
            setShowEmailDisclaimer(false);

            return isValid.email(value);
        },
        emailConfirmation: value => {
            isValid.emailConfirmation(value) && setShowEmailDisclaimer(false);
            setEmailConfirmation(isValid.emailConfirmation(value));

            return isValid.emailConfirmation(value);
        },
    };

    return (
        <>
            <div className="row md-form-group">
                <div className="col-sm-6">
                    <InputText
                        profileModel="userProfile.email"
                        label={formatText('field-email')}
                        type="text"
                        inputMode="email"
                        id="emailText"
                        name="emailText"
                        placeholder={formatText('placeholder-email')}
                        defaultValue={userProfile.email}
                        noFocusFromLabel
                        tooltip={<InfoTooltip text={formatText('tooltip-email')} />}
                        validations={{
                            required: isRequired,
                            valid: handleValidation.email,
                        }}
                        isNotValidated={() => submitButtonValidations(false)}
                        isValidated={() => submitButtonValidations(true)}
                        onFocus={() => setShowEmailDisclaimer(true)}
                        messagesError={{
                            required: formatText('validation-fieldRequired'),
                            valid: formatText('validation-email'),
                        }}
                        userProfileForm={userProfileForm}
                        userProfile={userProfile}
                        formActions={formActions}
                    />
                </div>
            </div>
            <div className="row md-form-group">
                <div className="col-sm-6">
                    <InputText
                        innerRef={emailConfirmationRef}
                        profileModel="userProfile.emailConfirmation"
                        label={formatText('field-emailConfirmationLabel')}
                        type="text"
                        inputMode="email"
                        id="emailConfirmation"
                        name="emailConfirmation"
                        placeholder={formatText('placeholder-email')}
                        defaultValue={userProfile.emailConfirmation}
                        pasteDisabled={true}
                        autoCompleteField={false}
                        validations={{
                            required: isRequired,
                            valid: handleValidation.emailConfirmation,
                        }}
                        isNotValidated={() => submitButtonValidations(false)}
                        isValidated={() => submitButtonValidations(true)}
                        onFocus={() => setShowEmailDisclaimer(true)}
                        messagesError={{
                            required: formatText('validation-fieldRequired'),
                            valid: formatText('validation-confirmEmail'),
                        }}
                        userProfileForm={userProfileForm}
                        userProfile={userProfile}
                        formActions={formActions}
                    />
                </div>
                <div className={showEmailDisclaimer ? 'col-sm-8 email-disclaimer' : 'hidden'}>
                    <HighLightedText
                        className="form__hightlight-text form__hightlight-text--warning-yellow"
                        icon={<i className="icons icons--icon-warning-2" />}
                    >
                        {formatText('initial-emailDisclaimer')}
                    </HighLightedText>
                </div>
            </div>
        </>
    );
};
